<template>
  <div style="background-color: gray">
    <van-sticky>
      <div v-if="OPsearchShow" style="background-color: white;margin: 0px 4px;height: 30px;display:flex;justify-content: space-around;align-items: center;">
        <div>
            <span>在厂：{{KanbWoks2}}</span>
            <span style="margin-left:10px;">任务量：{{KanbWoks1}}</span>
        </div>
        <el-switch
            style="display: block;width: 120px;" v-model="sreachAllShow" active-color="#409EFF" inactive-color="#409EFF"
            active-text="全部" inactive-text="个人" @change="sreachAllTap">
        </el-switch>
      </div>
      <van-search
        style="margin: 0px 4px 0 4px"
        show-action
        v-model="searchText"
        placeholder="请输入车主姓名/车牌号/工单号"
        @search="onSearch">
        <template #action>
            <div @click="onMoreFilter">更多筛选</div>
        </template>
      </van-search>
      <div style="background-color: white; padding-left: 36px; padding-bottom: 6px; margin: 0 4px 0 4px">
        <van-tag type="primary" size="medium"
                 v-for="procedureId of filters.procedureIds" :key="procedureId" style="margin: 0 4px">
          {{activeMiddleProcedureMap[procedureId] | trim }}
        </van-tag>
        <van-tag type="primary" size="medium"
                 v-for="state of filters.states" :key="state" style="margin: 0 4px">
          {{filters.allStates[state]}}
        </van-tag>
        <van-tag type="primary" size="medium"
                 v-for="carstate of filters.carstates" :key="carstate" style="margin: 0 4px">
          {{filters.allCarstates[carstate]}}
        </van-tag>
        <van-tag type="primary" size="medium"
                 v-for="day of filters.deliveryDays" :key="day" style="margin: 0 4px">
          {{deliveryDayMap[day]}}
        </van-tag>
        <van-tag type="primary" size="medium"
                 v-for="teamId of filters.teamIds" :key="teamId" style="margin: 0 4px">
          {{teamMap[teamId].name}}
        </van-tag>
        <van-tag type="primary" size="medium"
                 v-for="userId of filters.consultantIds" :key="userId" style="margin: 0 4px">
          {{consultantMap[userId]}}
        </van-tag>
      </div>
    </van-sticky>
    <transition-group name="list-complete">
      <div v-for="(work, index) of activeWorkList" :key="work.id"
           v-loading="work.loading"
           style="background-color: white; margin: 0 4px 8px 4px; padding: 6px; overflow: hidden;"
           class="list-complete-item">
        <div style="display: flex; justify-content: space-between" @click="showDetail(work)">
          <div>
            <div style="height: 28px; line-height: 28px;" :style="{'margin-top': index > 0 ? '6px' : 0}">
              <label
                style="margin-left: 43px; color: #1890ff; border: 1px solid black; font-size: 14px; border-radius: 2px; padding: 0 3px">
                {{work.carNo | carNo}}
              </label>
              <label v-if="work.ownerName" class="value">{{work.ownerName}}</label>
            </div>
            <div style="display: flex; align-items: center;">
              <label class="value" style="margin-left: 44px;">
                {{work.brandName + ' - ' + work.model}}
              </label>
            </div>
            <div>
              <label class="label">颜色</label>
              <label class="value"
                     style="border: 1px solid black; box-sizing:border-box; width: 80px; height: 17px"
                     :style="{backgroundColor: work.color}">
              </label>
            </div>
            <div>
              <label class="label">交车时间</label><label class="value">{{work.estimateDeliveryTime}}</label>
            </div>
            <div>
              <label class="label">服务顾问</label><label class="value">{{work.consultantName}}</label>
            </div>
            <div>
              <label class="label" style="color:red;">当前工序</label><label class="value" style="color:red;">
              {{work.procedureId | valueName('Procedure')}}</label>
            </div>
            <div>
              <label class="label">施工人</label>
              <label v-if="work.technicianId" class="value">{{work.technicianName}}</label>
              <label v-else-if="work.machineTechnicianName" class="value">{{work.machineTechnicianName}}</label>
              <label v-else class="value">暂无</label>
            </div>
            <div>
              <label class="label">是否加急</label><label class="value">{{work.urgent ? '是' : '否'}}</label>
            </div>
            <div>
              <label class="label">是否中断</label><label class="value">{{work.status === 'INTERRUPT' ? '是' : '否'}}</label>
            </div>
            <div>
              <label class="label">钣金工时</label><label class="value">{{work.sheetMetalWH}}</label>
            </div>
            <div>
              <label class="label">油漆幅数</label><label class="value">{{work.paintArea}}</label>
            </div>
          </div>
          <div v-if="!history && !isDueToday(work)"
               style="margin-right: -32px; margin-top: -13px; height: 100px;">
            <div
              style="margin-left: 0px; transform:rotate(45deg); width: 90px; height: 50px; display: flex; justify-content: center; align-items: flex-end;"
              :style="{'background-color': isOverdue(work) ? 'red' : '#1989FA'}">
              <label style="font-size: 14px; color: white; font-weight: bold">
                {{isOverdue(work) ? '超时'+isRemainingDay(work)+'天' : '剩余'+isRemainingDay(work)+'天'}}
              </label>
            </div>
          </div>
          <div v-if="!history && isDueToday(work)"
               style="margin-right: -32px; margin-top: -13px; height: 100px;">
            <div
              style="margin-left: 0px; transform:rotate(45deg); width: 90px; height: 50px; display: flex; justify-content: center; align-items: flex-end;background-color:orange">
              <label style="font-size: 14px; color: white; font-weight: bold">
                '今日应交'
              </label>
            </div>
          </div>
        </div>
        <div class="van-hairline--top"></div>
        <div v-show="!history && !delivery" v-if="!sreachAllShow"
             style="display: flex; justify-content: center; margin-top: 10px; margin-bottom: 8px">
          <van-button size="normal" plain type="info" style="height: 32px; margin: 0 6px"
                      v-for="menuItem of selectMobileMenuByWork(work)" :key="menuItem.command"
                      @click="onCommand(menuItem.command, work)">
            {{menuItem.name}}
          </van-button>
        </div>
      </div>
    </transition-group>
    <van-popup v-model="page.showDetail" position="right" style="width: 100%; height: 100%">
          <wx-work-detail :work="page.work" :show.sync="page.showDetail" :pattern="page.pattern"></wx-work-detail>
        </van-popup>
        <van-popup v-model="page.showInterrupt" position="right" style="width: 100%; height: 100%">
          <wx-interrupt-page :work="page.work" :show.sync="page.showInterrupt"
                             :pattern="page.pattern"></wx-interrupt-page>
        </van-popup>
        <van-popup v-model="page.showQualityInspect" position="right" style="width: 100%; height: 100%">
          <wx-quality-inspect-page :work="page.work" :show.sync="page.showQualityInspect"></wx-quality-inspect-page>
        </van-popup>
    <van-popup v-model="showFilter" position="bottom" :style="{height}" round
               safe-area-inset-bottom>
      <wx-work-list-filter :filters="filters" :show.sync="showFilter" :history="history" :delivery="delivery">
      </wx-work-list-filter>
    </van-popup>
  </div>
</template>

<script>
  import { Button, Popup, Search, Sticky, Tag, Toast } from 'vant'
  import WxWorkDetail from '@/views/wx/work-detail'
  import {
    completeDelivery,
    completeSettlement,
    endWash,
    endWork,
    getWorkDetail,
    pushWork,
    rework,
    startWash,
    startWork,
    stopWork,
    getKanbanWorks,
    allOrgans
  } from '@/utils/request'
  import WxInterruptPage from '@/views/wx/work-detail/WxInterruptPage'
  import WxQualityInspectPage from '@/views/wx/work-detail/WxQualityInspectPage'
  import WxWorkListFilter from '@/views/wx/WxWorkListFilter'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { selectMobileMenuByWork } from '@/store/modules/menu'
  import authority from '@/utils/authority'

  export default {
    name: 'WxWorkListPanel',
    mixins: [shareDataMixin],
    components: {
      WxWorkListFilter,
      WxQualityInspectPage,
      WxInterruptPage,
      WxWorkDetail,
      [Search.name]: Search,
      [Sticky.name]: Sticky,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Tag.name]: Tag
    },
    props: {
      delivery: Boolean,
      history: Boolean,
      workList: {
        type: Array,
        required: true
      },
      technicianIdMap: Object,
      teamIdMap: Object
    },
    data () {
      return {
        OPsearchShow: null,
        KanbWoks1: null,
        KanbWoks2: null,
        sreachAllShow: false,
        remainingDay: '',
        selectMobileMenuByWork,
        searchText: '',
        showFilter: false,
        filters: {
          allStates: {
            WAIT_CONFIRM: '待派工',
            WAIT: '待施工',
            RUN: '施工中',
            INTERRUPT: '中断',
            COMPLETED: '完工',
            TO_DELIVER: '待交车',
            DELIVERED: '待结算',
            REWORK: '已返工'
          },
          allCarstates: {
              OVERDUE_CARS: '超时交车',
              DELAY_CARS: '延迟交车',
              REWORK_CARS: '返工车辆',
              INTERRUPT_CARS: '中断车辆',
              TODAY_CARS: '今日进厂',
              DUE_TODAY_CARS: '今日应交',
              TODAY_DELIVERY_CARS: '今日已交',
              DUE_TOMORROW_CARS: '明日应交',
              ON_SITE_CARS: '在厂车辆'
          },
          procedureIds: [],
          states: [],
          carstates: [],
          deliveryDayList: [
            {
              name: '昨日',
              delta: -1
            },
            {
              name: '今日',
              delta: 0
            },
            {
              name: '明日',
              delta: 1
            },
            {
              name: '后天',
              delta: 2
            },
            {
              name: '第四天',
              delta: 3
            },
            {
              name: '第五天',
              delta: 4
            },
            {
              name: '第六天',
              delta: 5
            },
            {
              name: '第七天',
              delta: 6
            },
            {
              name: '应交延迟',
              delta: -100
            }
          ],
          deliveryDays: [],
          technicianIds: [],
          consultantIds: [],
          teamIds: [],
          enterDate: null
        },
        page: {
          work: {},
          pattern: null,
          showDetail: false,
          showInterrupt: false,
          showQualityInspect: false
        }
      }
    },
    created () {
      this.$store.dispatch('data/kvList', 'ActiveMiddleProcedure')
      // 初始化获取个人和全部工单数量
      getKanbanWorks(0).then(response => {
        var beginWork = response.data.beginWork.workList.length
        var list1 = []
        for (const columns of response.data.middleWorks) {
          for (const column of columns) {
            list1.push.apply(list1, column.workList)
          }
        }
        var middleWorks = list1.length
        var list2 = []
        for (const column of response.data.endWorks) {
          list2.push.apply(list2, column.workList)
        }
        var endWorks = list2.length
        this.KanbWoks1 = beginWork + middleWorks + endWorks
      })
      getKanbanWorks(1).then(response => {
        var beginWork = response.data.beginWork.workList.length
        var list1 = []
        for (const columns of response.data.middleWorks) {
          for (const column of columns) {
            list1.push.apply(list1, column.workList)
          }
        }
        var middleWorks = list1.length
        var list2 = []
        for (const column of response.data.endWorks) {
          list2.push.apply(list2, column.workList)
        }
        var endWorks = list2.length
        this.KanbWoks2 = beginWork + middleWorks + endWorks
      })
      var that = this
      allOrgans().then(response => {
        response.data.forEach((item) => {
            if (item.type === 'WORKSHOP' && item.code === process.env.VUE_APP_CODE) {
                if (item.viewAll === 1) {
                    that.OPsearchShow = true
                } else {
                    that.OPsearchShow = false
                }
            }
        })
      })
    },
    mounted () {
        if (this.$route.query.carNo !== null && this.$route.query.carNo !== '' && this.$route.query.carNo !== undefined) {
            this.searchText = this.$route.query.carNo
        }
        if (this.$route.query.carstater !== undefined && this.$route.query.carstater !== null && this.$route.query.carstater !== '') {
            this.filters.carstates.push(this.$route.query.carstater)
        }
        if (this.$route.query.stater !== undefined && this.$route.query.stater !== null && this.$route.query.stater !== '') {
            this.filters.states.push(this.$route.query.stater)
        }
        if (this.$route.query.itemprocedureId !== undefined && this.$route.query.itemprocedureId !== null && this.$route.query.itemprocedureId !== '') {
            this.filters.procedureIds.push(parseInt(this.$route.query.itemprocedureId))
        }
    },
    methods: {
      sreachAllTap () {
        if (this.sreachAllShow) {
            this.$store.dispatch('work/getKanbanWorks', 1)
        } else {
            this.$store.dispatch('work/getKanbanWorks', 0)
        }
      },
      onSearch () {
      },
      onMoreFilter () {
        this.showFilter = true
      },
      showDetail (work, pattern) {
        this.page.work = work
        this.page.pattern = pattern
        this.page.showDetail = true
        getWorkDetail(work.id).then(data => {
          Object.assign(this.page.work, {
            remarks: data.remarks,
            statusReason: data.statusReason,
            prevProcedureId: data.prevProcedureId,
            prevTechnicianName: data.prevTechnicianName
          })
        })
      },
      onCommand (command, work) {
        switch (command) {
          case authority.CONFIRM_WORK:
          case authority.DISPATCH:
            this.showDetail(work, command)
            break

          case authority.PUSH:
            if (!work.technicianId) {
              Toast.fail('没有技师，不能推进！')
              return
            }
            work.loading = true
            pushWork(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.REWORK:
            work.loading = true
            rework(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.INTERRUPT:
          case authority.MACHINE_REPAIR:
            this.page.work = work
            this.page.showInterrupt = true
            this.page.pattern = command
            break

          case authority.STOP:
            work.loading = true
            stopWork(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.START_WORK:
            work.loading = true
            startWork(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.END_WORK:
            work.loading = true
            endWork(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.DELIVERY:
            work.loading = true
            completeDelivery(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.SETTLEMENT:
            work.loading = true
            completeSettlement(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.START_WASH:
            work.loading = true
            startWash(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.END_WASH:
            work.loading = true
            endWash(work.id).catch(() => {
              work.loading = false
            })
            break

          case authority.QUALITY:
            this.page.work = work
            this.page.showQualityInspect = true
            break
        }
      },
      isOverdue (work) {
        return new Date(work.estimateDeliveryTime.replace(/-/g, '/')).getTime() < new Date().getTime()
      },
      isRemainingDay (work) {
        var a = new Date(work.estimateDeliveryTime.replace(/-/g, '/')).getTime()
        var b = new Date().getTime()
        var c = Math.abs(a - b) / (1000 * 3600 * 24)
        var d
        if (a - b < 0) { d = Math.floor(c) } else { d = Math.floor(c) + 1 }
        return d
      },
      isDueToday (work) {
        return new Date(work.estimateDeliveryTime.replace(/-/g, '/')).toDateString() === new Date().toDateString()
      },
      isEnterToday (work) {
        return new Date(work.enterTime).toDateString() === new Date().toDateString()
      },
      isDueTomorrow (work) {
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)
        return new Date(work.estimateDeliveryTime).toDateString() === tomorrow.toDateString()
      }
    },
    computed: {
      activeWorkList () {
        let list = this.workList

        if (this.searchText) {
          list = list.filter(work => {
            if (work.ownerName && work.ownerName.indexOf(this.searchText) !== -1) return true
            if (work.carNo.indexOf(this.searchText) !== -1) return true
            if (work.extraId) {
              return work.extraId.indexOf(this.searchText) !== -1
            }
            return work.id.indexOf(this.searchText) !== -1
          })
        }

        if (this.filters.procedureIds.length > 0) {
          list = list.filter(work => this.filters.procedureIds.indexOf(work.procedureId) >= 0)
        }
        if (this.filters.states.length > 0) {
          list = list.filter(work => {
            switch (work.procedureType) {
              case 'WAIT_CONFIRM':
                if (this.filters.states.indexOf('WAIT_CONFIRM') >= 0) return true
                break
              case 'QUALITY':
                return false
              case 'CAR_WASH':
                if (this.filters.states.indexOf('COMPLETED') >= 0) return true
                break
              case 'DELIVERY':
              case 'SETTLEMENT':
                if (this.filters.states.indexOf('COMPLETED') >= 0) return true
                if (this.filters.states.indexOf(work.status) >= 0) return true
                break
              default:
                // 返工
                if (this.filters.states.indexOf('REWORK') >= 0) {
                  if (work.reworked) return true
                }
                return this.filters.states.indexOf(work.status) >= 0
            }
          })
        }
        if (this.filters.carstates.length > 0) {
            list = list.filter(work => {
                switch (this.filters.carstates[0]) {
                case 'ON_SITE_CARS':
                  if (work.procedureType !== 'SETTLEMENT') return true
                  break

                case 'OVERDUE_CARS':
                  if (this.isOverdue(work)) return true
                  break

                case 'TODAY_CARS':
                  if (this.isEnterToday(work)) return true
                  break

                case 'DELAY_CARS':
                  if (work.delayed) return true
                  break

                case 'DUE_TODAY_CARS':
                  if (this.isDueToday(work)) return true
                  break

                case 'REWORK_CARS':
                  if (work.reworked) return true
                  break

                case 'DUE_TOMORROW_CARS':
                  if (this.isDueTomorrow(work)) return true
                  break

                case 'TODAY_DELIVERY_CARS':
                  if ((work.status === 'SETTLED' &&
                    new Date(work.deliveryTime).toDateString() === new Date().toDateString())) {
                    return true
                  }
                  break

                case 'INTERRUPT_CARS':
                  if (work.status === 'INTERRUPT') return true
                  break
                }
            })
        }
 if (this.filters.deliveryDays.length > 0) {
          list = list.filter(work => {
            for (const deliveryDay of this.filters.deliveryDays) {
              if (deliveryDay < -1) return true
              let targetDate = new Date()
              targetDate.setDate(targetDate.getDate() + deliveryDay)
              targetDate = targetDate.format('yyyy-MM-dd')
              const estimateDeliveryTime = work.estimateDeliveryTime.split(' ')[0]
              if (estimateDeliveryTime === targetDate) return true
            }
            return false
          })
        }

        if (this.filters.technicianIds.length > 0) {
          list = list.filter(work => {
            if (this.history) {
              for (const technicianId of this.technicianIdMap[work.id] || []) {
                if (this.filters.technicianIds.indexOf(technicianId) >= 0) return true
              }
              return false
            }
            return work.technicianId !== null && this.filters.technicianIds.indexOf(work.technicianId) >= 0
          })
        }
        if (this.filters.teamIds.length > 0) {
          list = list.filter(work => {
            if (this.history) {
              for (const teamId of this.teamIdMap[work.id] || []) {
                if (this.filters.teamIds.indexOf(teamId) >= 0) return true
              }
              return false
            }
            return work.teamId !== null && this.filters.teamIds.indexOf(work.teamId) >= 0
          })
        }
        if (this.filters.consultantIds.length > 0) {
          list = list.filter(work => {
            return this.filters.consultantIds.indexOf(work.consultantId) >= 0
          })
        }
        if (this.filters.enterDate) {
          list = list.filter(work =>
            work.enterTime.split(' ')[0] === this.filters.enterDate
          )
        }
        // 最后按交车日期排序
        return list.sort((a, b) =>
          new Date(a.estimateDeliveryTime.replace(/-/g, '/')).getTime() - new Date(b.estimateDeliveryTime.replace(/-/g, '/')).getTime()
        )
      },
      height () {
        if (this.history) return '60%'
        if (this.delivery) return '70%'
        return '90%'
      },
      deliveryDayMap () {
        const ret = {}
        this.filters.deliveryDayList.forEach(day => {
          ret[day.delta] = day.name
        })
        return ret
      },
      style () {
        return {
          'background-color': this.sreachAllShow ? '#1890ff' : 'transparent',
          color: this.sreachAllShow ? 'white' : '#333'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    display: inline-block;
    width: 100px;
    color: #646464;
    font-size: 14px;
    text-align: right;
    height: 28px;
    line-height: 28px;
  }

  .value {
    display: inline-block;
    color: black;
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    margin-left: 20px;
  }
</style>
